module.exports = __webpack_public_path__ + "assets/img/browser.d3be0de0.png";